import actions from './actions';

const { BRAND_LIST_BEGIN, BRAND_LIST_SUCCESS, BRAND_LIST_ERR } = actions;

const initState = {
  list: null,
  loading: false,
  error: null,
};

/**
 *
 * @todo impure state mutation/explaination
 */
const BrandReducer = (state = initState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case BRAND_LIST_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case BRAND_LIST_SUCCESS:
      return {
        ...state,
        list: data,
        loading: false,
      };
    case BRAND_LIST_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };
    default:
      return state;
  }
};
export default BrandReducer;
